import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import { Link } from "gatsby";
var Contact = /*#__PURE__*/ function (_Component) {
    _inheritsLoose(Contact, _Component);
    function Contact() {
        return _Component.apply(this, arguments) || this;
    }
    var _proto = Contact.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "container m-auto px-4"
        }, /*#__PURE__*/ React.createElement("section", {
            className: "flex items-center justify-center font-ibm lg:text-lg"
        }, /*#__PURE__*/ React.createElement("div", null, this.props.children, " "), /*#__PURE__*/ React.createElement(Link, {
            to: "/contact-us",
            className: "bg-black-primary ml-4 text-white min-w-max px-4 py-6"
        }, "Contact Us")));
    };
    return Contact;
}(Component);
export { Contact as default };
